import * as _ from 'underscore'
import { ConvertHelper, DataProvider, ToastHelper } from '../helpers'

import { Enums } from '../models/common'
import { OpActionType, OpActionData } from '../models/core'
import { ColumnInfo, OpActionResult } from '../models/custom'
import { OpAction } from '../models/core/op-action'
import { DataValue } from '../models/local'
import { DataProviderListResult } from './data-provider.interfaces'
import { OpActionPacket } from '../models/daq/op-action-packet'
import { DataProviderRequest } from './utils'

export class DataProviderAction {
	// Ctor

	constructor(private dataProvider: DataProvider) {}

	// Ctor End

	// Public Methods

	public getActionFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<DataProviderListResult<OpAction>> => {
		return this.dataProvider.sendFilterRequestWithSession<OpAction>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdAction, 'OpxActionFilter', 'OpxActionFilterResult')
	}

	public getActionParameters = (idActionType: number, referenceType: Enums.ReferenceType, referenceValue: any): JQueryPromise<OpActionData[]> => {
		return this.dataProvider
			.sendRequestWithSession('OpxGetActionParameters', { IdActionType: idActionType, ReferenceType: referenceType, ReferenceValue: referenceValue }, 'OpxGetActionParametersResult')
			.then((response: any) => {
				return DataProvider.convertArrayResult<OpActionData>(response, OpActionData)
			})
	}

	public checkActionStatus = (ids: number[]): JQueryPromise<OpAction[]> => {
		return this.dataProvider.sendRequestWithSession('OpxCheckActionStatus', { IdAction: ids }, 'OpxCheckActionStatusResult').then((response: any) => {
			return DataProvider.convertArrayResult<OpAction>(response, OpAction)
		})
	}

	public getCorrespondingActionType = (referenceValue: number[], referenceType: Enums.ReferenceType): JQueryPromise<OpActionType[]> => {
		return this.dataProvider
			.sendRequestWithSession('OpxGetCorrespondingActionType', { ReferenceValue: referenceValue, ReferenceType: referenceType }, 'OpxGetCorrespondingActionTypeResult')
			.then((response: any) => {
				return DataProvider.convertArrayResult<OpActionType>(response, OpActionType)
			})
	}

	public sendAction = (actionId: number, referenceValue: number[], referenceType: Enums.ReferenceType, dataValues: DataValue[]): JQueryPromise<OpActionResult[]> => {
		return this.dataProvider
			.sendRequestWithSession(
				'OpxSendAction',
				{ IdActionType: actionId, ReferenceValue: referenceValue, ReferenceType: referenceType, DataValues: _.size(dataValues) > 0 ? dataValues.map((data: DataValue) => data.toJSON()) : null },
				'OpxSendActionResult'
			)
			.then((response: any[]) => {
				return DataProvider.convertArrayResult<OpActionResult>(response, OpActionResult)
			})
	}

	public getAction = (actionId: number): DataProviderRequest<OpAction> => {
		const promise: JQueryPromise<OpAction> = this.dataProvider
			.sendRequestWithSession('OpxGetAction', { IdAction: actionId }, 'OpxGetActionResult')
			.then((response: any) => {
				const result: OpAction = new OpAction(response)

				// OpAction.loadNavigationProperties(this.dataProvider, [result])

				return result
			})
			.fail((error) => {
				const msg: string = ConvertHelper.getRequestErrorMessage(error)
				ToastHelper.showError(msg)
			})

		return DataProviderRequest.fromJQuery(promise)
	}

	public getActionPackets = (actionId: number): JQueryPromise<OpActionPacket[]> => {
		return this.dataProvider.sendRequestWithSession('OpxGetActionPacket', { IdAction: actionId }, 'OpxGetActionPacketResult').then((response: any[]) => {
			if (_.size(response) > 0) {
				return _.map(response, (item: any) => new OpActionPacket(item))
			}

			// OpAction.loadNavigationProperties(this.dataProvider, [result])

			return []
		})
	}

	public sendAstGsmCommandAction = (serialNbrs: number[], command: string) => {
		return this.dataProvider.sendRequestWithSession('OpxSendAstGsmDeviceCommand', { serialNbr: serialNbrs, command: command }, 'OpxSendAstGsmDeviceCommandResult').then((response: any[]) => {
			return DataProvider.convertArrayResult<OpActionResult>(response, OpActionResult)
		})
	}

	// Public Methods End
}
